module.exports = __webpack_public_path__ + "assets/img/end_1.8f78429b.png";